export default __webpack_public_path__ + "img/dBSdDBfF.dd413bf9.svg";